import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, Route } from 'react-router-dom';
import { isAuthenticated } from 'utils/auth';
import {
  ROLE_USER,
  ROLE_SUPER_ADMIN,
  ROLE_UCP_ADMIN,
  ROLE_CONTENT_ADMIN,
  ROLE_QUIZ_ADMIN,
  ROLE_TRAINING_ADMIN,
  ROLE_USER_ADMIN,
  userHasRole,
  userIsContracted,
} from 'utils/roles';
import { useLocation } from 'react-router-dom';

const propTypes = {
  requiresContract: PropTypes.bool,
  role: PropTypes.oneOf([
    ROLE_USER,
    ROLE_SUPER_ADMIN,
    ROLE_UCP_ADMIN,
    ROLE_CONTENT_ADMIN,
    ROLE_QUIZ_ADMIN,
    ROLE_TRAINING_ADMIN,
    ROLE_USER_ADMIN,
  ]),
};

function PrivateRoute({ requiresContract, roles, component: Component, ...rest }) {
  const queryParams = useLocation().search;

  return (
    <Route
      {...rest}
      render={props =>
        isAuthenticated() && roles?.some(role => userHasRole(role)) && (!requiresContract || userIsContracted()) ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: isAuthenticated() ? `/403` : `/login`,
              search: queryParams.replace(/[?&]referrer=[a-zA-Z]*/, ''),
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
}

PrivateRoute.propTypes = propTypes;

export default PrivateRoute;
